import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';
import { SuccessIcon } from '../CustomIcons';

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  header: {
    fontSize: '16px',
    fontWeight: 700,
    color: '#455775'
  },
  body: {
    textAlign: 'center',
    padding: ' 0 16px',
    color: '#455775'
  },
  button: {
    borderRadius: 32
  },
  closeButtonWrapper: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    color: theme.palette.colorPalette[1],

    '&:hover': {
      cursor: 'pointer'
    }
  },
  actionButtonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  marginRight: {
    marginRight: theme.spacing(1)
  }
}));

const SuccessModal = ({ closeModal, action, content: ModalCustomContent } = {}) => {
  const classes = useStyles();
  const { t } = useTranslation(['common']);
  const handleActionClick = () => {
    action();
    closeModal();
  };

  return (
    <>
      <div className={classes.closeButtonWrapper} onClick={closeModal}>
        <HighlightOffIcon />
      </div>
      <div className={classes.iconWrapper}>
        <SuccessIcon />
      </div>
      <div>
        <ModalCustomContent />
      </div>
      <div className={classes.actionButtonsWrapper}>
        <Button
          onClick={closeModal}
          className={clsx(classes.button, classes.marginRight)}
          color="primary"
          variant="contained"
        >
          {t('accept')}
        </Button>
        <Button onClick={handleActionClick} className={classes.button} color="primary" variant="contained">
          {t('see employees')}
        </Button>
      </div>
    </>
  );
};

SuccessModal.propTypes = {
  closeModal: PropTypes.func,
  action: PropTypes.func,
  content: PropTypes.string
};

export default SuccessModal;
